import { defineStore } from "pinia";

export const useMembersStore = defineStore("MembersStore", {
  state: () => {
    return {
      associationsWithPraxisSoftware: {
        // assoc  e-mail domain with praxis software
        ALOSI:     "hin.email",
        ARLD:      "hin.email",
        ASPI:      "hin.physio",
        DLV:       "hin.email",
        EVS:       "hin.email",
        PHYSIO:    "hin.physio",
        PP:        "hin.physio",
        "SVO-FSO": "hin.email",
      },
      associationSelection: "",
      defaultAssociation: { key: "K_VERBAND", value: undefined },
      timer: 1000 * 60 * 60 * 24, // 24 hours
      outOfScopeAssociationKeys: ["FSP", "CHIRO", "SVMED"],
    };
  },
  getters: {
    hasPraxisSoftware: (state) => {
      return state.associationsWithPraxisSoftware[state.associationSelection];
    },
    hasAssociation: (state) => {
      return state.associationSelection !== "" && state.associationSelection !== state.defaultAssociation.key;
    },
    hasUniqueDiscount: (state) => {
      return state.associationSelection === state.outOfScopeAssociationKeys[2];
    }
  },
  persist: {
    storage: sessionStorage,
  }
});
